import { useMemo } from "react";
import CommonStringCell from "tables/common/CommonStringCell";
import CommonDateCell from "tables/common/CommonDateCell";
import ActionsCell from "./cells/ActionsCell";

export default function useColumns() {
  return useMemo(
    () => [
      {
        header: "Report Name",
        accessorKey: "name",
        size: 213,
        cell: CommonStringCell,
      },
      { header: "Frequency", accessorKey: "frequency", size: 100, cell: CommonStringCell },
      { header: "Starting On", accessorKey: "startingOn", size: 120, cell: CommonDateCell },
      { header: "Subject", accessorKey: "subject", size: 250, cell: CommonStringCell },
      { header: "Recipients", accessorKey: "recipients", size: 400, cell: CommonStringCell },
      {
        header: "status",
        accessorKey: "status",
        size: 100,
        cell: CommonStringCell,
      },
      {
        id: "actions",
        header: "Actions",
        size: 213,
        cell: ActionsCell,
      },
    ],
    [],
  );
}
